import PropTypes from 'prop-types';
export const BackgroundImageContainerPropTypes = {
    /** React nodes */
    children: PropTypes.node,
    /** Main image source */
    src: PropTypes.string.isRequired,
    /** Blur or image with min size source */
    fallbackSrc: PropTypes.string.isRequired,
    /** Webp optional image */
    webpSrc: PropTypes.string
};
export const BackgroundImageContainerDefaultProps = {};
//# sourceMappingURL=BackgroundImageContainer.prop-types.js.map